import { render } from "./VideoBanner.vue?vue&type=template&id=029599fa"
import script from "./VideoBanner.vue?vue&type=script&lang=js"
export * from "./VideoBanner.vue?vue&type=script&lang=js"

import "./VideoBanner.vue?vue&type=style&index=0&id=029599fa&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__